import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import Container from "@material-ui/core/Container";
import SwipeableViews from "react-swipeable-views";
import { connect } from "react-redux";

// Custom components
import { Modal } from "../general";
import Stepper from "./Stepper";
import Code from "./CodeInput";
import Success from "./Success";
import EmailForm from "./EmailForm";
import {
  requestCode,
  userValidateCodeRequest,
} from "../../redux/actions/authActions";

const LoginModal = ({
  open,
  setOpen,
  openSignUp,
  requestCode,
  userValidateCodeRequest,
  t,
}) => {
  // Slides
  const [slideIndex, setSlideIndex] = useState(0);
  const [containerIndex, setContainerIndex] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  // Loading state
  const [emailLoading, setEmailLoading] = useState(false);
  const [codeLoading, setCodeLoading] = useState(false);

  // Form state
  const [formData, setFormData] = useState({});
  const [formErrors, setFormErrors] = useState({});

  const [codeErrorMsg, setCodeErrorMsg] = useState("");

  const reset = () => {
    setFormData({});
    setFormErrors({});
    setSlideIndex(0);
    setContainerIndex(0);
  };

  const nextSlide = () => {
    setSlideIndex(slideIndex + 1);
    setCodeLoading(false);
    setEmailLoading(false);
  };

  const editFormData = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const editErrors = (valueObj) => {
    setFormErrors({ ...formErrors, ...valueObj });
  };

  const handleRequestCode = () => {
    setEmailLoading(true);
    let data = { email: formData["email"] };
    requestCode(data).then(
      (codeRes) => {
        nextSlide();
        console.log(codeRes.data);
      },
      (codeRes) => {
        setEmailLoading(false);
        editErrors({ email: "There is no account with this email." });
      }
    );
  };

  const handleValidateCode = (code) => {
    setCodeLoading(true);
    userValidateCodeRequest(formData["email"], code).then(
      () => {
        setContainerIndex(1);
        setIsComplete(true);
      },
      (reason) => {
        // console.log(reason);
        setCodeLoading(false);
        setCodeErrorMsg(t("auth.invalidCode"));
      }
    );
  };

  return (
    <Modal
      open={open}
      title={t("auth.logIn")}
      setOpen={(visible) => {
        if (visible === false) {
          reset();
        }
        setOpen(visible);
      }}
      modalProps={{ keepMounted: false }}
      style={{ overflow: "hidden" }}
    >
      <Container component="main" maxWidth="xs" style={{ padding: 0 }}>
        <div>
          <SwipeableViews index={containerIndex}>
            <div style={{ padding: "0 20px" }}>
              <Stepper
                index={slideIndex}
                steps={[t("auth.fillInEmail"), t("auth.logIn")]}
                style={{ margin: 0, padding: "20px 0 10px 0" }}
              />
              <SwipeableViews index={slideIndex}>
                <EmailForm
                  openSignUp={openSignUp}
                  type="LOG_IN"
                  requestCode={handleRequestCode}
                  editFormData={editFormData}
                  formData={formData}
                  editErrors={editErrors}
                  formErrors={formErrors}
                  emailLoading={emailLoading}
                  setEmailLoading={setEmailLoading}
                  t={t}
                />
                <Code
                  validateCode={handleValidateCode}
                  loading={codeLoading}
                  codeErrorMsg={codeErrorMsg}
                  setCodeErrorMsg={setCodeErrorMsg}
                  t={t}
                />
              </SwipeableViews>
            </div>
            <Success isComplete={isComplete} />
          </SwipeableViews>
        </div>
      </Container>
    </Modal>
  );
};

export default connect((state) => state, {
  requestCode,
  userValidateCodeRequest,
})(withTranslation("common")(LoginModal));
